export default "__VITE_ASSET__BHvxghCh__"